import {useLocation} from '@reach/router'


export const useQuery = (queryParams) => {
    const search = new URLSearchParams(useLocation().search)
    return search.get(queryParams)
  }